import styles from './PlusIcon.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function PlusIcon({className}) {
  const classNameArray = className?.split(' ') || [];

	return (
			<svg className={cx(['plus-icon', ...classNameArray])} width="100%" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
				<rect width="40" height="40" rx="20" fill="#202020" />
				<path d="M20.4727 9.38367V31.563" stroke="white" strokeWidth="4.43587" strokeLinecap="round" />
				<path d="M9.38354 20.141H31.5629" stroke="white" strokeWidth="4.43587" strokeLinecap="round" />
			</svg>
	);
}
